module.exports = __webpack_public_path__ + "static/media/symbol-logo-gray.53773d02.svg";